import type { CategoryWithVods, Vod } from '@setplex/tria-api'
import type { TFunction } from '~/core/i18n'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { UiCategoryWithVods, VodWithPrice } from '~/shared/interfaces'
import type { FormattedVodWithPrice } from './index.h'

import { formatDateDuration, timeWithin } from '~/shared/helpers/date'
import {
  extendMediaItemByLabelPrice,
  getLeftTimeString,
  getProgress,
  getViewedTimeString,
} from '~/shared/tools'

export const formatCategoryWithVodsToUi = (
  data: CategoryWithVods | null,
  adjust: AdjustPurchaseableFn,
  t: TFunction
): UiCategoryWithVods | null => {
  if (!data) return null

  const formattedContent = data.content.map((vod) =>
    extendMediaItemByLabelPrice(adjust(vod))
  ) as VodWithPrice[]

  const name = data.id === 0 ? t('all') : data.name

  return {
    ...data,
    name,
    content: formattedContent,
  }
}

export const formatVod = ({
  item,
  adjust,
  t,
}: {
  item: Vod
  adjust?: AdjustPurchaseableFn
  t: TFunction
}): FormattedVodWithPrice => {
  const mediaByLabelPrice = extendMediaItemByLabelPrice(
    adjust ? adjust(item) : item
  ) as VodWithPrice

  const { duration, stoppedTime } = (item || {}) as Vod

  const progress = getProgress({
    duration,
    stoppedTime,
  })

  const timeLeft = getLeftTimeString({
    duration,
    stoppedTime,
    t,
  })

  const viewedTime = getViewedTimeString(stoppedTime)
  const { hours, minutes } = timeWithin(duration || 0)
  const formattedDuration = formatDateDuration({
    duration: { hours, minutes },
    short: true,
  })

  return {
    ...mediaByLabelPrice,
    length: formattedDuration,
    progress,
    timeLeft,
    viewedTime,
    // WBS sends i18n keys, not copy — the bundle owns the wording.
    contentLabels: (item?.labels ?? []).map((key) => t(key)),
  }
}
